'use strict';

angular.module('teams').factory('TeamData', [
	'$resource',
	function ($resource) {
		return $resource(
			'v1/teams/:teamId/data/:category',
			{
				teamId: '@teamId',
				category: '@category'
			},
			{
				get:
					{
						method:'GET',
						cache : false
					},
				set:
					{
						method: 'PUT',
						cache: false
					},
				remove:
					{
						method:'DELETE',
						cache: false
					}
			}
		);
	}
]);

